import { render, staticRenderFns } from "./PortfolioSection.vue?vue&type=template&id=2cdb4c4c&"
import script from "./PortfolioSection.vue?vue&type=script&lang=js&"
export * from "./PortfolioSection.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports